import React from 'react';
import { observer } from 'mobx-react';
import { Fade } from '@material-ui/core';
import reportLocales from 'globals/locales/report';
import { isSuccessState } from 'globals/utils';
import { useReportContext } from 'contexts/report/ReportContext';
import FsHeaderMedium from 'ui-elements/typography/FsHeaderMedium';
import FsDefaultFallbackComponent from 'ui-elements/loaders/FsDefaultFallbackComponent';
import FsGridContainer from 'ui-elements/grid/FsGridContainer';
import FsGridItem from 'ui-elements/grid/FsGridItem/FsGridItem';
import ReportActionButtons from './ReportActionButtons';
import {
  ContainerBox,
  HeaderBox,
  Caption,
  Item,
  Value,
  List,
} from './ReportBasicInfoSection.style-elements';

// Locales
const {
  basicInfo: {
    reference: referenceLabel,
    city: cityLabel,
    country: countryLabel,
    ipAddress: ipAddressLabel,
    buttonLabels,
  },
} = reportLocales;

const ReportBasicInfoSection: React.FC = () => {
  const {
    report: {
      basicInfo: {
        reference: referenceValue,
        city: cityValue,
        country: countryValue,
        ip_address: ipAddressValue,
        username,
        status,
      },
    },
  } = useReportContext();

  if (!isSuccessState(status))
    return (
      <FsDefaultFallbackComponent
        status={status}
        data-test="default-fallback-component"
      />
    );
  return (
    <Fade in={isSuccessState(status)} timeout={1000}>
      <FsGridContainer>
        <FsGridItem xs={12} isVerticalPadding={false}>
          <ContainerBox data-test="report-basic-info-section-container">
            <HeaderBox>
              <FsHeaderMedium>{username || 'Noname'}</FsHeaderMedium>
              <List>
                {cityValue && (
                  <Item>
                    <Caption>{cityLabel}</Caption>
                    <Value>{cityValue}</Value>
                  </Item>
                )}
                {countryValue && (
                  <Item>
                    <Caption>{countryLabel}</Caption>
                    <Value>{countryValue}</Value>
                  </Item>
                )}
                {ipAddressValue && (
                  <Item>
                    <Caption>{ipAddressLabel}</Caption>
                    <Value>{ipAddressValue}</Value>
                  </Item>
                )}
                {referenceValue && (
                  <Item>
                    <Caption>{referenceLabel}</Caption>
                    <Value>{referenceValue}</Value>
                  </Item>
                )}
              </List>
            </HeaderBox>
            <ReportActionButtons buttonLabels={buttonLabels} />
          </ContainerBox>
        </FsGridItem>
      </FsGridContainer>
    </Fade>
  );
};

ReportBasicInfoSection.displayName = 'ReportBasicInfoSection';

export default observer(ReportBasicInfoSection);
